<template>
  <div>
    <div class="d-none d-md-flex" style="margin-bottom: 60px;">
      <div style="margin-right: 16px;">
        <div class="preview-logo">
          <img v-if="company.logo_src" v-bind:src="company.logo_src" style="width: 100%;">
        </div>
      </div>
      <div class="d-flex flex-column" style="justify-content: space-evenly;">
        <div>
          <div class="comp-name">
            {{ company.name }}
          </div>
          <div class="comp-city">
            {{ company.city + ', ' + company.country }}
          </div>
        </div>
        <div>
          <div style="display: inline-block;" v-if="parseInt(rating) > 70">
            <div class="rating-dot green-rating" v-for="i in Math.floor(parseInt(rating) / 10)"></div>
            <div class="rating-dot null-rating" v-for="i in (10 - Math.floor(parseInt(rating) / 10))"></div>
          </div>
          <div style="display: inline-block;" v-else-if="parseInt(rating) > 30">
            <div class="rating-dot yellow-rating" v-for="i in Math.floor(parseInt(rating) / 10)"></div>
            <div class="rating-dot null-rating" v-for="i in (10 - Math.floor(parseInt(rating) / 10))"></div>
          </div>
          <div style="display: inline-block;" v-else-if="parseInt(rating) <= 30">
            <div class="rating-dot red-rating" v-for="i in Math.floor(parseInt(rating) / 10)"></div>
            <div class="rating-dot null-rating" v-for="i in (10 - Math.floor(parseInt(rating) / 10))"></div>
          </div>
          <div style="display: inline-block;" v-else-if="!parseInt(rating)">
            <div class="rating-dot null-rating" v-for="i in 10"></div>
          </div>
          <br>
          <span>{{ rating }} Remote friendly</span>
        </div>
      </div>
    </div>

    <div class="summary">
      Precautionary Measures<br>
      <div v-text="getWorkFromHomeText()"></div>
      <div v-text="getTravelText()"></div>
      <div v-text="getVisitorsText()"></div>
      <div v-text="getEventsText()"></div>
    </div>

    <div class="summary">
      Other Measures<br>
      <div v-text="company.other_remarks || 'N/A'"></div>
    </div>

    <div class="summary">
      General<br>
      <div v-text="getVideoConferenceText()"></div>
      <div v-text="getProjectManagementText()"></div>
      <div v-text="getClearSOPText()"></div>
      <div v-text="getCommunicationsProtocolText()"></div>
    </div>

    <div class="summary" v-if="remoteMeasures.has_tech_team">
      Tech Team<br>
      <div v-text="getGitUsageText()"></div>
      <div v-text="getScheduledScrumMeetingsText()"></div>
    </div>

    <div class="remote-readiness-text">Remote Readiness Rating: <span v-text="rating"></span></div>
  </div>
</template>

<script>
import Options from '../TextOptionsConfig';
import remoteReadinessRating from '../RemoteReadinessRating';
import DropDownOptions from '../DropdownOptionsConfig';

export default {
  props: ['company', 'remoteMeasures', 'skipKeys'],

  computed: {
    rating () {
      return remoteReadinessRating(this.remoteMeasures, this.skipKeys || ['help_remote_ready']) + '%';
    },
  },

  methods: {
    getWorkFromHomeText () {
      return Options['workFromHomeText'][this.company.allow_work_from_home];
    },

    getTravelText () {
      return Options['travelText'][this.company.allow_travel];
    },

    getVisitorsText () {
      return Options['visitorsText'][this.company.allow_visitors];
    },

    getEventsText () {
      return Options['eventsText'][this.company.allow_events];
    },

    getGitUsageText () {
      return Options['usesGitText'][this.remoteMeasures.uses_git];
    },

    getVideoConferenceText () {
      return Options['videoConferenceText'][this.remoteMeasures.uses_video_conference_tools];
    },

    getProjectManagementText () {
      return Options['projectManagementText'][this.remoteMeasures.uses_project_management_tools];
    },

    getClearSOPText () {
      return Options['clearSOPText'][this.remoteMeasures.has_clear_sops];
    },

    getRemoteReadyHelpText () {
      return Options['helpRemoteReadyText'][this.remoteMeasures.needs_help_remote_ready];
    },

    getCommunicationsProtocolText () {
      return Options['setCommsProtocolText'][this.remoteMeasures.set_communications_protocol];
    },

    getScheduledScrumMeetingsText () {
      return Options['scheduleRegularScrumText'][this.remoteMeasures.schedule_regular_scrums];
    },
  },
};
</script>

<style scoped lang="scss">
.summary {
  color: #808fa4;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.5px;
  line-height: 22px;
  margin-bottom: 32px;

  > div {
    color: #303030;
    font-family: "Open Sans", sans-serif;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 28px;
  }
}

.remote-readiness-text {
  color: #303030;
  font-family: "Open Sans", sans-serif;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 24px;
}

.comp-name {
  color: #303030;
  font-family: 'Lato', sans-serif;
  font-size: 22px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 30px;
}

.comp-city {
  color: #8392a6;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 19px;
}

.preview-logo {
  height: 96px;
  width: 96px;
  border-radius: 50%;
  overflow: hidden;
}

.sm-p-0 {
  @media (max-width: 328px) {
    padding: 0 !important;
  }
}
</style>
